export function PaymentAgreement() {
  return (
    <div>
      <p>
        This Payment Agreement ("Agreement") is entered into by and between
        Graze Social PBC ("Graze"), the sponsor ("Sponsor"), and the content
        feed operator ("Curator"). By engaging in a campaign on Graze's
        platform, the Sponsor and Curator agree to the terms outlined below.
      </p>
      <h3>
        <span>1. Definitions</span>
      </h3>
      <ul>
        <li>
          <b>Sponsor: </b>
          <span>
            The party purchasing impressions (CPM) for a content feed.
          </span>
        </li>
        <li>
          <b>Curator: </b>
          <span>
            The party operating the content feed where the impressions will be
            displayed.
          </span>
        </li>
        <li>
          <b>Campaign: </b>
          <span>The total set of impressions purchased by the Sponsor.</span>
        </li>
        <li>
          <b>Impression: </b>
          <span>
            A single instance of content being displayed to an end user within a
            campaign.
          </span>
        </li>
      </ul>
      <h3>
        <span>2. Payments and Fees</span>
      </h3>
      <ol>
        <li>
          <span>Sponsor Payments:</span>
          <ul>
            <li>
              <span>
                Sponsors propose campaigns to Curators. Once started, the
                minimum transaction size, even in the event of cancellation, is
                $1.
              </span>
            </li>
            <li>
              <span>
                Otherwise, payments will be remitted on a daily use basis during
                the campaign.
              </span>
            </li>
            <li>
              <span>Graze retains 30% of the payment as a platform fee.</span>
            </li>
            <li>
              <span>The remaining 70% is designated for the Curator.</span>
            </li>
            <li>
              <span>
                Graze covers all transaction costs associated with the payment
                process.
              </span>
            </li>
          </ul>
        </li>
        <li>
          <span>Curator Payouts:</span>

          <ul>
            <li>
              <span>
                Payouts to Curators are available on a rolling basis following
                the completion of impressions for a campaign.
              </span>
            </li>
            <li>
              <span>
                Curators will be responsible for any bank fees associated with
                the payout.
              </span>
            </li>
          </ul>
        </li>
      </ol>

      <h3>
        <span>3. Refund Policy</span>
      </h3>
      <ol>
        <li>
          <span>Full Refunds:</span>
          <ul>
            <li>
              <span>
                Full refunds are available to the Sponsor only if the campaign
                has not started displaying any impressions.
              </span>
            </li>
          </ul>
        </li>
        <li>
          <span>Prorated Refunds:</span>
          <ul>
            <li>
              <span>
                Once a campaign has begun, refunds are prorated based on the
                number of impressions that have already been displayed.
              </span>
            </li>
            <li>
              <span>
                Sponsors acknowledge that bank or transaction fees associated
                with their initial payment will not be refunded.
              </span>
            </li>
          </ul>
        </li>
        <li>
          <span>Chargebacks:</span>
          <ul>
            <li>
              <span>
                Graze will actively dispute all chargebacks filed by Sponsors.
              </span>
            </li>
          </ul>
        </li>
      </ol>

      <h3>
        <span>4. Responsibilities of Graze</span>
      </h3>
      <ol>
        <li>
          <span>Transaction Costs:</span>
          <ul>
            <li>
              <span>
                Graze is responsible for covering all payment transaction costs,
                ensuring that neither Sponsors nor Curators bear these expenses.
              </span>
            </li>
          </ul>
        </li>
        <li>
          <span>Platform Operations:</span>
          <ul>
            <li>
              <span>
                Graze will facilitate the passthrough of payments and ensure
                timely payouts to Curators, as outlined in this Agreement.
              </span>
            </li>
          </ul>
        </li>
        <li>
          <span>Impressions Overages:</span>
          <ul>
            <li>
              <span>
                Occasionally, due to technical constraints, campaigns may
                experience an over-provisioning of impressions, where sponsored
                content is impressed a higher number of times than the contract
                between Curator and Sponsor originally indicated. In those
                events, Graze will cease impressions as quickly as technically
                possible, and cap the charge amount to the originally
                agreed-upon terms of the contract.
              </span>
            </li>
          </ul>
        </li>
      </ol>

      <h3>
        <span>5. Curator Obligations</span>
      </h3>
      <ol>
        <li>
          <span>Ad Display:</span>
          <ul>
            <li>
              <span>
                Curators agree to display the impressions as part of their feed
                in accordance with campaign parameters set by the Sponsor.
              </span>
            </li>
            <li>
              <span>
                Curators are strictly prohibited from manipulating,
                astro-turfing, or fraudulently increasing view counts in any
                manner. Graze reserves the right to log and analyze forensic
                data for auditing purposes to detect and prevent such
                activities.
              </span>
            </li>
          </ul>
        </li>
        <li>
          <span>Payout Eligibility:</span>
          <ul>
            <li>
              <span>
                Curators will only receive payouts for impressions that are
                verified as displayed by Graze's platform.
              </span>
            </li>
          </ul>
        </li>
      </ol>

      <h3>
        <span>6. Dispute Resolution</span>
      </h3>
      <ol>
        <li>
          <span>Chargebacks and Refunds:</span>
          <ul>
            <li>
              <span>
                Graze reserves the right to review and resolve disputes related
                to campaigns, including chargebacks and refunds, in accordance
                with this Agreement.
              </span>
            </li>
          </ul>
        </li>
        <li>
          <span>Liability:</span>
          <ul>
            <li>
              <span>
                Graze's liability is limited to the amounts collected from the
                Sponsor for a campaign, minus any applicable fees retained.
              </span>
            </li>
          </ul>
        </li>
      </ol>

      <h3>
        <span>7. General Terms</span>
      </h3>
      <ol>
        <li>
          <span>Amendments:</span>
          <ul>
            <li>
              <span>
                Graze reserves the right to modify this Agreement at any time,
                with prior notice to Sponsors and Curators.
              </span>
            </li>
          </ul>
        </li>
        <li>
          <span>Governing Law:</span>
          <ul>
            <li>
              <span>
                This Agreement will be governed by and construed in accordance
                with the laws of the jurisdiction where Graze is headquartered.
              </span>
            </li>
          </ul>
        </li>
        <li>
          <span>Entire Agreement:</span>
          <ul>
            <li>
              <span>
                This Agreement constitutes the entire understanding between
                Graze, the Sponsor, and the Curator regarding the subject matter
                and supersedes all prior agreements, representations, or
                understandings.
              </span>
            </li>
          </ul>
        </li>
      </ol>
    </div>
  );
}
